import axios from 'axios';

// In development: /api/quote is handled by src/setupProxy.js (CRA dev proxy)
// In production:  /api/quote is handled by api/quote.js (Vercel serverless fn)
// Either way the API key lives server-side — never in the browser bundle.
export const fetchRandomQuote = async (category = '') => {
    const params = new URLSearchParams({ _t: Date.now() });
    if (category) params.set('category', category);
    const response = await axios.get(`/api/quote?${params}`);
    const item = Array.isArray(response.data) ? response.data[0] : response.data;
    return item;
};

export const getErrorMessage = (err) => {
    if (err.response?.status === 429)
        return 'Too many requests — please wait a moment before trying again.';
    if (err.response?.status >= 500) return 'The quote service is unavailable. Please try again later.';
    if (!err.response) return 'Network error. Please check your connection.';
    return 'Failed to fetch quote. Please try again.';
};
